import React from 'react';
import { useActiveSection } from '../hooks/useActiveSection';

const sections = [
  { id: 'hero', label: 'Introduction' },
  { id: 'expertise', label: 'Expertise' },
  { id: 'experience', label: 'Experience' },
  { id: 'education', label: 'Education' },
  { id: 'projects', label: 'Projects' },
  { id: 'github', label: 'GitHub' }
];

const Sidebar = () => {
  const activeSection = useActiveSection();

  return (
    <aside className="sidebar">
      <div className="sidebar-label">Index</div>
      <ul className="sidebar-nav" id="sidebar-nav">
        {sections.map(({ id, label }) => (
          <li key={id}>
            <a
              href={`#${id}`}
              data-sec={id}
              className={activeSection === id ? 'active' : ''}
            >
              {label}
            </a>
          </li>
        ))}
      </ul>
    </aside>
  );
};

export default Sidebar;
